import type { SnowplowClient } from '@nextmar/snowplow-sdk';
import { getZeeloolSnowplowClient } from './client';

/** 仅记录当前文档已成功显式同步的客户ID；历史用户资料不是Tracker writer。 */
const syncedUsers = new WeakMap<Window, { client: SnowplowClient; userId: string | null }>();

/** setter成功后登记，按window及client对象隔离重配、测试和不同文档。 */
export function recordSyncedSnowplowUserId(client: SnowplowClient, userId: string | null): void {
  if (typeof window !== 'undefined') syncedUsers.set(window, { client, userId });
}

/** 只读当前显式客户writer；未配置或新client明确匿名，不由uuid或缓存资料推导。 */
export function getCapturedSnowplowUserId(): string | null {
  if (typeof window === 'undefined') return null;
  const synced = syncedUsers.get(window);
  return synced && synced.client === getZeeloolSnowplowClient() ? synced.userId : null;
}
